import { campaignScoutingAPIClient } from '@/marketing/infrastructure/influencer/campaign/scouting/campaignScoutingAPIClient';
import type { ScoutingExportScope, ScoutingPageRow } from '@/marketing/models/campaignScouting';

export async function fetchScoutingExportRows(campaignId: string, scope: ScoutingExportScope, signal: AbortSignal): Promise<ScoutingPageRow[]> {
  if (signal.aborted)
      throw new DOMException('Export canceled', 'AbortError');
  const exported = await campaignScoutingAPIClient.exportAll(campaignId, { scope }, signal);
  if (signal.aborted)
      throw new DOMException('Export canceled', 'AbortError');
  if (exported.pageInfo.hasMore || exported.pageInfo.nextCursor) {
    throw new Error('The full export is unavailable. Refresh and try again.');
  }
  return exported.rows;
}
